// extracted by mini-css-extract-plugin
module.exports = {"main":"Policies_main__UipSD","scrollable":"Policies_scrollable__28aEt"};